import { Group } from "@mantine/core";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <Group position="center" mb="md">
      <div>
        <a
          style={{ color: "#9ca6af" }}
          href={"https://bookitup.de/datenschutz"}
        >
          Datenschutz
        </a>{" "}
      </div>
      <div style={{ color: "#9ca6af" }}>|</div>
      <div>
        <a style={{ color: "#9ca6af" }} href={"https://bookitup.de/impressum"}>
          Impressum
        </a>{" "}
      </div>
    </Group>
  );
};
